module.exports = __webpack_public_path__ + "static/media/rails.50c36248.jpg";